export default __webpack_public_path__ + "12548603cc8e09bb42dda3c201b0cb00.svg";